module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "home_index",
    staticClass: "home_index"
  }, [_vm._v("\n  作品列表\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-75bbe430"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/page/activity.vue
// module id = 503
// module chunks = 1